import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import React from 'react';

export type HlIconProps = {
  icon: IconProp;
  className?: string;
  size:
    | 'xxsmall'
    | 'xsmall'
    | 'small'
    | 'medium'
    | 'large'
    | 'xlarge'
    | 'xxlarge';
};

export const HlIcon = ({ icon, className, size }: HlIconProps) => {
  return (
    <span className={clsx('hl-icon', `icon-${size}`, className)}>
      <FontAwesomeIcon icon={icon} />
    </span>
  );
};

export default HlIcon;
